<template>
  <Dropdown
    v-model="selectedEpisode"
    :options="episodesList"
    option-label="title"
    option-value="episode_id"
    placeholder="All Episodes"
    class="tw-border-none tw-outline-none tw-shadow-none tw-bg-none tw-bg-transparent tw-items-center tw-max-w-full sm:tw-max-w-72"
    input-class="tw-text-3xl md:tw-text-[40px] tw-font-light tw-p-0 tw-leading-normal"
    panel-class="tw-max-w-xs md:tw-max-w-sm lg:tw-max-w-lg xl:tw-max-w-2xl"
    filter
    @change="emits('selectEpisode', selectedEpisode)"
  >
  </Dropdown>
</template>

<script setup>
import Dropdown from "primevue/dropdown";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

const emits = defineEmits(["selectEpisode"]);
const props = defineProps(["selectedShow"]);

const store = useStore();

const token = localStorage.getItem("podcasterToken");

const selectedEpisode = ref("all");

const episodesList = computed(() => {
  const allEpisodesOption = { episode_id: "all", title: "All Episodes" };
  const episodes = store.getters.episodes || [];
  if (props.selectedShow === "all") return [allEpisodesOption];
  const filtered = episodes.filter(
    (item) => item.show_id === props.selectedShow
  );
  if (filtered.length === 0) return [allEpisodesOption];
  return [allEpisodesOption, ...filtered];
});

const fetchEpisodes = () => {
  if (!store.getters.episodes || store.getters.episodes.length == 0) {
    store.dispatch("loadEpisodes", { token });
  }
};

onMounted(() => {
  fetchEpisodes();
});
</script>
